// import { camelcaseKeys } from 'camelcase-keys';
const ck = require('camelcase-keys');

/**
 * Adapter for API response in snake_case
 * will return a new object where keys are camelCase and snake_case keys are
 * removed (optionally)
 *
 * @param {Object} response - API Response
 * @param {Array} exclude - API Response keys to exclude from conversions
 * @returns {Object} response with response keys camelCased
 *
 * @see {https://github.com/sindresorhus/camelcase-keys}
 * @example
 * const converted = helpers.adapter(data, ['mls_id']);
 */
const camelCaseResponseAdapter = (response, exclude = []) => ck(response, {
  exclude,
  deep: true,
});


export default {
  camelCaseResponseAdapter,
};



// WEBPACK FOOTER //
// ./src/lib/api/index.js